import { CheckoutStyles } from "@omni/ui/brand/checkout/checkout.styles";
import { Button } from "@omni/ui/components/Button/button.component";
import { useSelector } from "react-redux";

import * as CheckoutCustomerDetailsFormSelectors from "@/redux/modules/value/checkout/customerDetails/checkoutCustomerDetailsForm.selectors";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { useCheckout } from "../useCheckout.hook";

const CheckoutDetailsButton = () => {
    const { t } = useGranite();
    const isLoading = useSelector(
        CheckoutCustomerDetailsFormSelectors.isLoading
    );

    const { cartLoading } = useCheckout();

    return (
        <Button
            test="checkoutDetailsButton-button-submit"
            color={CheckoutStyles.submitButton?.color || "success"}
            fullWidth={true}
            type={"submit"}
            size={"lg"}
            form={"checkoutCustomerDetails"}
            loading={isLoading || cartLoading}
        >
            {t("checkout.customerDetails.button.submit")}
        </Button>
    );
};

export { CheckoutDetailsButton };
